export default "/images/deko-logo-and-text.svg";